import { render } from "./odn-modal-procedure.vue?vue&type=template&id=779a9716&scoped=true"
import script from "./odn-modal-procedure.vue?vue&type=script&lang=js"
export * from "./odn-modal-procedure.vue?vue&type=script&lang=js"

import "./odn-modal-procedure.vue?vue&type=style&index=0&id=779a9716&lang=scss&scoped=true"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779a9716"]])

export default __exports__